import { OptionColor, OptionTier } from '@order/steps/types'
import { GradientPoints, GradientProps } from '@ui/effects/Gradient/types'
import { LogoComponentProps } from '@shell/Logo'
import { colors as c } from '@ui/colors'
import { Platform } from 'react-native'

export const borderRadius = 32
export const borderRadiusImage = 24
export const imageHeight = Platform.select({ default: 80, web: 128 })

export const logos: Record<OptionTier, LogoComponentProps['name']> = {
  default: undefined,
  standard: undefined,
  comfort: undefined,
  premium: undefined,
  highend: undefined,
  worldclass: 'steiner',
}

export const getLogoHeight = (logo: LogoComponentProps['name']) =>
  logo === 'steiner' ? 24 : 20

const vertical: GradientPoints = { start: [0.5, 0], end: [0.5, 1] }
const horizontal: GradientPoints = { start: [0, 0.5], end: [1, 0.5] }

export const gradients: Record<OptionTier, GradientProps[]> = {
  default: [
    {
      ...vertical,
      colors: [c.neutral[400], c.neutral[500], c.neutral[600], c.neutral[800]],
    },
  ],
  standard: [
    { ...vertical, colors: [c.neutral[600], c.neutral[500], c.neutral[300]] },
  ],
  comfort: [
    { ...vertical, colors: [c.latte[800], c.latte[500], c.latte[300]] },
  ],
  premium: [{ ...vertical, colors: [c.lime[800], c.lime[500], c.lime[300]] }],
  highend: [
    { ...vertical, colors: [c.magenta[800], c.magenta[500], c.magenta[300]] },
    {
      ...horizontal,
      colors: [c.white0, c.magenta[700], c.magenta[600], c.magenta[700]],
    },
  ],
  worldclass: [
    { ...vertical, colors: [c.blue[900], c.blue[700], c.blue[400]] },
    {
      start: [0, 0.5],
      end: [0.75, 0],
      colors: [c.blue0, c.blue0, c.blue[900], c.blue0, '#3262F1', c.blue0],
    },
  ],
}

export const colorOutline: Record<OptionTier, string> = {
  default: c.neutral[400],
  standard: c.neutral[400],
  comfort: c.latte[400],
  premium: c.lime[600],
  highend: c.magenta[600],
  worldclass: c.blue[600],
}

export const colorOption: Record<OptionTier, OptionColor> = {
  default: 'default',
  standard: 'gray',
  comfort: 'latte',
  premium: 'green',
  highend: 'magenta',
  worldclass: 'blue',
}
